import fullpage from 'fullpage.js';

function init() {

  const slider = document.getElementById('fullpage');
  const slide_up = document.getElementById('c-footer__slide_up');
  const slide_down = document.getElementById('c-footer__scroll');
  const slide_top = document.getElementById('c-hero_slider__slide_top');
  const slide_counter = document.getElementById('c-footer__slide_counter');
  const slide = document.getElementsByClassName('c-hero_slider__slide_section');
  const slide_count = slide.length - 1;

  const footer_scroll = document.getElementById("c-footer__scroll");
  const footer_bottom = document.getElementById("c-footer__bottom");

  if(footer_scroll){

    const scroll_p = footer_scroll.querySelector('p');
    const scroll_svg = footer_scroll.querySelector('.c-footer__scroll_icon');
    scroll_svg.setAttribute('style', 'fill: white !important');

  }

  if (!slider) {
    return;
  }

  slide[0].classList.add("active");

  new fullpage('#fullpage', {

    sectionSelector: '.c-hero_slider__slide_section',
    fixedElements: '.c-footer-sticky',
    licenseKey: '93F05B26-DBE14529-BCDB4A4C-EFD44F96',
    autoScrolling: true,
    continuousVertical: false,
    css3: true,
    easing: 'easeOutQuart',
    easingcss3: 'ease',
    navigation: true,
    navigationPosition: 'right',
    slidesNavigation: true,

    onLeave: function(origin, destination, direction){
      let scroll_p = footer_scroll.querySelector('p');
      let scroll_svg = footer_scroll.querySelector('.c-footer__scroll_icon');
  		if(destination.index != 0){
        if(scroll_p){
          scroll_p.style.opacity = 0;
          scroll_svg.style.fill = "";
        }
  		} else {
        if(scroll_p){
          scroll_p.style.opacity = 1;
          scroll_svg.setAttribute('style', 'fill: white !important');
        }
      }
      slide[origin.index].classList.remove("active");
      slide[destination.index].classList.add("active");
      show_footer(destination.index);

  	}

  });

  slide_down.addEventListener('click', function(e) {
    e.preventDefault();
		fullpage_api.moveSectionDown();
  });

  function show_footer(slide_number) {
    if(slide_number == slide_count) {
      footer_scroll.classList.remove('active');
      footer_bottom.classList.add('active');
    } else {
      footer_scroll.classList.add('active');
      footer_bottom.classList.remove('active');
    }
  }

  /*
slide_up.addEventListener('click', function(e) {
    e.preventDefault();
		fullpage_api.moveSectionUp();
  });

  slide_top.addEventListener('click', function(e) {
    e.preventDefault();
		fullpage_api.moveTo(1);
  });
*/


}

export default init;
